import React from 'react';

type CheckIconProps = {
  color?: string;
};

const CheckIcon: React.FC<CheckIconProps> = ({ color = '#55951B' }) => {
  return (
    <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_10032_29391)">
        <path
          d="M14.4839 8.76409C14.4839 8.55576 14.417 8.38463 14.283 8.2507L13.2674 7.24623C13.126 7.10487 12.9586 7.03418 12.7652 7.03418C12.5717 7.03418 12.4043 7.10487 12.2629 7.24623L7.70937 11.7886L5.18705 9.26632C5.04568 9.12495 4.87827 9.05427 4.68481 9.05427C4.49136 9.05427 4.32395 9.12495 4.18258 9.26632L3.16696 10.2708C3.03303 10.4047 2.96606 10.5758 2.96606 10.7842C2.96606 10.9851 3.03303 11.1525 3.16696 11.2864L7.20714 15.3266C7.3485 15.468 7.51592 15.5386 7.70937 15.5386C7.91026 15.5386 8.08139 15.468 8.22276 15.3266L14.283 9.26632C14.417 9.13239 14.4839 8.96498 14.4839 8.76409ZM16.1469 6.26967C16.1469 6.26967 16.3385 6.59798 16.7216 7.2546C17.1048 7.91123 17.2964 9.01707 17.2964 10.5721C17.2964 12.1272 16.9132 13.5613 16.1469 14.8746C15.3805 16.1878 14.3407 17.2276 13.0274 17.994C11.7142 18.7604 10.2801 19.1436 8.72499 19.1436C7.16993 19.1436 5.73578 18.7604 4.42254 17.994C3.10929 17.2276 2.06949 16.1878 1.30312 14.8746C0.536749 13.5613 0.153564 12.1272 0.153564 10.5721C0.153564 9.01707 0.536749 7.58292 1.30312 6.26967C2.06949 4.95643 3.10929 3.91662 4.42254 3.15025C5.73578 2.38388 7.16993 2.0007 8.72499 2.0007C10.2801 2.0007 11.7142 2.38388 13.0274 3.15025C14.3407 3.91662 15.3805 4.95643 16.1469 6.26967Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_10032_29391">
          <rect width="17.15" height="20" fill="white" transform="matrix(1 0 0 -1 0.149902 20.5723)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CheckIcon;
